import "./Project.css";
import profile from "../Images/profile-pic.png";
const Project = () => {
  return (
    <div id="projects">
      <h2 className="text-heading">Projects</h2>

      <div className="card">
        <img src={profile} alt="" />
        <h4>Chat Room</h4>
        <p className="title">
          Built using <em> ReactJS </em>and <em>Firebase</em>{" "}
        </p>
        <p>
          <a href="https://vue-chat-2557e.web.app/">
            <button className="btn btn-dark live"> See Live</button>
          </a>
        </p>
      </div>
    </div>
  );
};

export default Project;
